import React from 'react';
import { lifecycle } from 'recompose';

const NEW_DESIGN_CLASS = 's-v2';

const withNewDesignStyles = lifecycle({
  componentDidMount() {
    document.documentElement.classList.add(NEW_DESIGN_CLASS);
  },
  componentWillUnmount() {
    document.documentElement.classList.remove(NEW_DESIGN_CLASS);
  },
});

export default withNewDesignStyles;

export const withNewDesignStylesComponent = withNewDesignStyles(({ children }) => (
  <div>
    {children}
  </div>
));
